import { createReducer, on } from '@ngrx/store';
import { setAttributes, setEmail, setIsPendoInitialised, setOpenSesame, setSchoolName, setUser } from './auth.actions';
import { CognitoUser } from '@aws-amplify/auth'; 

export type UserAttributes = {
  'custom:grade': string;
  'custom:platform': string;
  'custom:school': string;
  'custom:teacher': string;
  'custom:userType': 'student' | 'teacher';
  'custom:videoRecAgreement': string;
  email: string;
  schoolName : string;
  email_verified: string;
  family_name: string;
  given_name: string;
  nickname?: string;
  sub: string;
  identities?: string;
  loginType?: string;
  externalUserId?: string;
  'custom:etsGUID'?: string;
  'custom:adRoles'?: string;
};

export interface State {
  email: string | undefined;
  isPendoInitialised : boolean;
  openSesame: string | undefined;
  user: CognitoUser | undefined;
  attributes : UserAttributes | undefined;
  schoolName : string | undefined
}

export const authFeatureKey = 'auth';

export const initialState: State = {
  email: undefined,
  isPendoInitialised : false,
  openSesame: undefined,
  user: undefined,
  schoolName : undefined,
  attributes : undefined

};

export const reducer = createReducer(
  initialState,
  on(setEmail, (state, { payload }) => ({ ...state, email: payload })),
  on(setOpenSesame, (state, { payload }) => ({ ...state, openSesame: payload })),
  on(setUser, (state, { payload }) => ({ ...state, user: payload })),
  on(setAttributes, (state, { payload }) => ({ ...state, attributes: payload })),
  on(setSchoolName, (state, { payload }) => ({ ...state, schoolName: payload })),
  on(setIsPendoInitialised, (state, { payload }) => ({ ...state, isPendoInitialised: payload })),
);
